import { Injectable } from '@angular/core';

import { BetSlipType } from '@bpos';

import { BetslipType } from '../../../../../../core/betslip-type';
import { CriteriaType, IRewardToken } from '../../../../reward-tokens.model';
import { TokenValidationInput, TokensCriteriaValidatorBase } from '../../criteria-validator-base.service';

@Injectable()
export class BetAndGetSlipTypeValidator extends TokensCriteriaValidatorBase<IRewardToken, CriteriaType> {
    override type = CriteriaType.SlipType;
    isValid(token: IRewardToken, state: TokenValidationInput): boolean {
        const currentSelectedType = state?.selectedType;
        const picksCount = state.selectedPicks.length;

        if (token.filter?.betSlipType) {
            switch (token.filter.betSlipType) {
                case BetSlipType.Single: {
                    return currentSelectedType === BetslipType.Single && picksCount === 1;
                }
                case BetSlipType.Combo: {
                    return currentSelectedType === BetslipType.Combo || currentSelectedType === BetslipType.Teaser;
                }
                case BetSlipType.System: {
                    return currentSelectedType === BetslipType.System;
                }
            }
        }

        return true;
    }
}
